import { useState } from "react";
import { Link } from "react-router-dom";
import { serviceDetails, processSteps } from "@/mocks/pagesData";
import ServicesInquiryForm from "./components/ServicesInquiryForm";

export default function ServicesPage() {
  const [active, setActive] = useState(1);
  const [expanded, setExpanded] = useState<number | null>(1);
  const current = serviceDetails.find((s) => s.id === active) || serviceDetails[0];
  const toggleExpanded = (id: number) => setExpanded((prev) => (prev === id ? null : id));

  return (
    <main className="pt-20">
      <section className="relative py-20 bg-black overflow-hidden">
        <div className="absolute inset-0">
          <img src="https://readdy.ai/api/search-image?query=abstract%20technology%20network%20dark%20background%20glowing%20connections%20nodes%20futuristic%20minimal%20deep%20space%20cinematic%20wide&width=1440&height=500&seq=svchero&orientation=landscape" alt="Services background" className="w-full h-full object-cover object-top opacity-20" />
          <div className="absolute inset-0 bg-gradient-to-r from-black/98 to-black/80" />
        </div>
        <div className="absolute top-0 left-0 right-0 h-px bg-gradient-to-r from-transparent via-[#C8F135]/40 to-transparent" />
        <div className="relative z-10 max-w-7xl mx-auto px-4 md:px-8 text-center">
          <div className="inline-flex items-center gap-2 bg-[#C8F135]/10 border border-[#C8F135]/20 rounded-full px-4 py-1.5 mb-6">
            <span className="text-[#C8F135] text-xs font-semibold uppercase tracking-wider">What We Do</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-black text-white mb-5">
            Our <span style={{color: "#C8F135"}}>Services</span>
          </h1>
          <p className="text-slate-300 text-lg max-w-2xl mx-auto">From strategy to execution, empower your enterprise with intelligent, agentic, and scalable AI solutions.</p>
        </div>
      </section>

      {/* DESKTOP */}
      <section className="hidden lg:block py-20 bg-white">
        <div className="max-w-7xl mx-auto px-8">
          <div className="grid grid-cols-3 gap-8">
            <div className="flex flex-col gap-2">
              {serviceDetails.map((s) => (
                <button key={s.id} onClick={() => setActive(s.id)}
                  className={`flex items-center gap-4 px-5 py-4 rounded-xl text-left cursor-pointer transition-all border whitespace-nowrap ${active === s.id ? "bg-black border-black text-white" : "bg-white border-slate-100 text-slate-700 hover:border-slate-200 hover:bg-slate-50"}`}>
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${active === s.id ? "bg-[#C8F135]" : "bg-slate-50"}`}>
                    <i className={`${s.icon} text-lg ${active === s.id ? "text-black" : "text-slate-600"}`} />
                  </div>
                  <span className="font-semibold text-sm">{s.title}</span>
                  {active === s.id && <div className="ml-auto w-5 h-5 flex items-center justify-center"><i className="ri-arrow-right-line text-[#C8F135]" /></div>}
                </button>
              ))}
            </div>
            <div className="col-span-2">
              <div className="rounded-xl overflow-hidden border border-slate-100 h-full">
                <div className="relative w-full h-72">
                  <img src={current.image} alt={current.title} className="w-full h-full object-cover object-top" />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/70 to-transparent" />
                  <div className="absolute top-4 left-4 inline-flex items-center gap-2 bg-[#C8F135] rounded-lg px-4 py-1.5">
                    <i className={`${current.icon} text-black text-sm`} />
                    <span className="text-black text-xs font-bold">{current.title}</span>
                  </div>
                </div>
                <div className="p-8 bg-white">
                  <p className="font-semibold text-sm mb-2" style={{color: "#9bc400"}}>{current.tagline}</p>
                  <h2 className="text-2xl font-black text-slate-900 mb-4">{current.title}</h2>
                  <p className="text-slate-500 text-sm leading-relaxed mb-6">{current.description}</p>
                  <div className="grid grid-cols-2 gap-3 mb-8">
                    {current.features.map((f) => (
                      <div key={f} className="flex items-center gap-2 text-sm text-slate-700">
                        <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#C8F135]/20 flex-shrink-0">
                          <i className="ri-check-line text-[#9bc400] text-xs" />
                        </div>
                        {f}
                      </div>
                    ))}
                  </div>
                  <Link to="/contact" className="inline-flex items-center gap-2 px-6 py-3 rounded-lg bg-black text-[#C8F135] font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-zinc-800 transition-colors">
                    Get a Free Consultation <i className="ri-arrow-right-line" />
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* MOBILE */}
      <section className="lg:hidden py-10 bg-white">
        <div className="max-w-2xl mx-auto px-4 flex flex-col gap-3">
          {serviceDetails.map((s) => {
            const isOpen = expanded === s.id;
            return (
              <div key={s.id} className={`rounded-xl border overflow-hidden transition-all duration-300 ${isOpen ? "border-black" : "border-slate-100"}`}>
                <button onClick={() => toggleExpanded(s.id)} className={`w-full flex items-center gap-4 px-5 py-4 text-left cursor-pointer transition-colors ${isOpen ? "bg-black" : "bg-white hover:bg-slate-50"}`}>
                  <div className={`w-10 h-10 flex items-center justify-center rounded-lg flex-shrink-0 ${isOpen ? "bg-[#C8F135]" : "bg-slate-100"}`}>
                    <i className={`${s.icon} text-lg ${isOpen ? "text-black" : "text-slate-600"}`} />
                  </div>
                  <span className={`font-bold text-sm flex-1 ${isOpen ? "text-white" : "text-slate-800"}`}>{s.title}</span>
                  <div className="w-6 h-6 flex items-center justify-center flex-shrink-0">
                    <i className={`text-base transition-transform duration-300 ${isOpen ? "ri-subtract-line text-[#C8F135]" : "ri-add-line text-slate-400"}`} />
                  </div>
                </button>
                {isOpen && (
                  <div className="bg-white">
                    <div className="relative w-full h-44 overflow-hidden">
                      <img src={s.image} alt={s.title} className="w-full h-full object-cover object-top" />
                      <div className="absolute inset-0 bg-gradient-to-t from-black/50 to-transparent" />
                    </div>
                    <div className="p-5">
                      <p className="font-semibold text-xs mb-1" style={{color: "#9bc400"}}>{s.tagline}</p>
                      <p className="text-slate-500 text-sm leading-relaxed mb-4">{s.description}</p>
                      <div className="flex flex-col gap-2 mb-5">
                        {s.features.map((f) => (
                          <div key={f} className="flex items-center gap-2 text-sm text-slate-700">
                            <div className="w-5 h-5 flex items-center justify-center rounded-full bg-[#C8F135]/20 flex-shrink-0">
                              <i className="ri-check-line text-[#9bc400] text-xs" />
                            </div>
                            {f}
                          </div>
                        ))}
                      </div>
                      <Link to="/contact" className="inline-flex items-center gap-2 px-5 py-2.5 rounded-lg bg-black text-[#C8F135] font-semibold text-sm whitespace-nowrap cursor-pointer hover:bg-zinc-800 transition-colors">
                        Get a Free Consultation <i className="ri-arrow-right-line" />
                      </Link>
                    </div>
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </section>

      {/* Process */}
      <section className="py-20 bg-slate-50">
        <div className="max-w-7xl mx-auto px-4 md:px-8">
          <div className="text-center mb-14">
            <div className="inline-flex items-center gap-2 border border-slate-200 rounded-full px-4 py-1.5 mb-5">
              <span className="text-slate-500 text-xs font-semibold uppercase tracking-wider">How We Work</span>
            </div>
            <h2 className="text-3xl md:text-4xl font-black text-slate-900">
              Our AI Delivery <span style={{color: "#9bc400"}}>Framework</span>
            </h2>
            <p className="text-slate-500 text-base mt-3 max-w-xl mx-auto">A proven 6-step process from discovery to empowerment.</p>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
            {processSteps.map((p, i) => (
              <div key={p.step} className="relative bg-white rounded-xl p-7 border border-slate-100">
                {i < processSteps.length - 1 && (
                  <div className="hidden lg:flex absolute top-10 -right-3 z-10 w-6 h-6 items-center justify-center">
                    <i className="ri-arrow-right-line text-slate-300 text-lg" />
                  </div>
                )}
                <div className="text-4xl font-black mb-4" style={{color: "#C8F135"}}>{p.step}</div>
                <h3 className="text-lg font-bold text-slate-900 mb-2">{p.title}</h3>
                <p className="text-sm text-slate-500 leading-relaxed">{p.desc}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      <ServicesInquiryForm />

      <section className="py-20 bg-black">
        <div className="max-w-3xl mx-auto px-4 md:px-8 text-center">
          <h2 className="text-3xl md:text-4xl font-black text-white mb-4">Not sure which service you need?</h2>
          <p className="text-zinc-400 mb-8">Let&apos;s talk. Our experts will assess your needs and recommend the right solution, no pressure, no obligation.</p>
          <Link to="/contact" className="inline-flex items-center gap-2 px-8 py-4 rounded-lg bg-[#C8F135] text-black font-bold text-base whitespace-nowrap cursor-pointer hover:bg-[#b5e000] transition-colors">
            Book a Free Strategy Call <i className="ri-arrow-right-line" />
          </Link>
        </div>
      </section>
    </main>
  );
}
